import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/composables/permissions/permissions';
import { encodeSearchQueryParams } from '@/libs/search/useQueryParams';
import { searchQueryParamsLatestScanResultFindingsForAsset } from './composables';

export const supplierMonitoringRoutes = [
  {
    path: 'monitoring',
    component: () => import('./SupplierMonitoring.vue'),
    children: [
      {
        path: 'scans',
        name: 'supplier-monitoring-scans',
        component: () => import('./SupplierMonitoringScans.vue'),
      },
      {
        path: 'domains',
        name: 'supplier-monitoring-domains',
        components: {
          default: () => import('@/modules/external-monitoring/AssetsPagesCombined.vue'),
          hero: () => import('@/modules/external-monitoring/AssetsHero.vue'),
        },
      },
      {
        path: 'findings',
        name: 'supplier-monitoring-findings',
        component: () => import('./SupplierFindings.vue'),
        props: (route) => ({
          assetName: route.params.assetName,
        }),
      },
      {
        path: 'findings/asset/:assetName?',
        name: 'supplier-monitoring-findings-of-asset',
        redirect: (route) => ({
          name: 'supplier-monitoring-findings',
          query: encodeSearchQueryParams(
            searchQueryParamsLatestScanResultFindingsForAsset(
              Array.isArray(route.params.assetName)
                ? route.params.assetName[0]
                : route.params.assetName,
            ),
          ),
          params: { ...route.params, assetName: undefined },
          replace: true,
        }),
      },
      {
        path: '',
        redirect: { name: 'supplier-monitoring-scans' },
      },
    ],
    meta: {
      permissions: [Permission.SuppliersExternalMonitoringView],
    },
  },
] satisfies RouteRecordRaw[];
